import { useContext } from 'react';
import { PermissionContext } from './PermissionProvider';

/**
 * useMenus — read the reactive menus projection from the Permission Access
 * Layer (SA-1592 Phase A2).
 *
 * Returns the decrypted menus array exactly as seeded by the provider (the
 * same value `authUtils.checkMenus()` produces), or `null` before it is
 * available. Consume this instead of calling `checkMenus()` directly so the
 * caller re-renders when permissions change (cross-tab `storage` event or the
 * same-tab `permissions:updated` event re-project `menus`).
 *
 * @returns {Array|null} the reactive menus array, or null when unavailable.
 */
export const useMenus = () => useContext(PermissionContext).menus;
